import 'Plugins/slickCarouselPlugin';

// Slick Carousel init
export default function initSlickCarousel() {

	jQuery('.slideshow').each(function() {
		const slider = jQuery(this);

		slider.slick({
			slidesToScroll: 1,
			slidesToShow: 1,
			infinite: true,
			rows: 0,
			arrows: false,
			dots: true,
  		fade: true,
			autoplay: true,
			autoplaySpeed: 8000,
			adaptiveHeight: true
		});
	});
}